module.exports = __webpack_public_path__ + "img/26.a62005e2.png";